module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"setOracleCredentialsCard.title":"Set Oracle Credentials","setOracleCredentialsCard.subtitle":"Oracle Cloud credentials","setOracleCredentialsCard.pemCredentials":"PEM Credentials","setOracleCredentialsCard.tenancyId":"Tenancy ID","setOracleCredentialsCard.userId":"User ID","setOracleCredentialsCard.regionId":"Region ID","setOracleCredentialsCard.fingerprint":"Fingerprint"}}')
  delete Component.options._Ctor
}
